module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.9500e026.png";